import React from 'react';
import { TextField } from '@mui/material';
import useStyles from './styles';
export default function NotesTexfield(_ref) {
  let value = _ref.value,
    onChange = _ref.onChange,
    label = _ref.label;
  const classes = useStyles();
  const maxRows = 10;
  const maxLength = 255;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    multiline: true,
    fullWidth: true,
    variant: "outlined",
    label: label,
    maxRows: maxRows,
    rows: 4,
    value: value,
    onChange: e => {
      if (e.target.value.length <= maxLength) onChange(e.target.value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.counter
  }, "(", value.length, "/", maxLength, ")"));
}